import { render, staticRenderFns } from "./CustomPartnerTariff.vue?vue&type=template&id=433ba55c&"
import script from "./CustomPartnerTariff.vue?vue&type=script&lang=ts&"
export * from "./CustomPartnerTariff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports